module.exports = __webpack_public_path__ + "img/1080_16.97bb225e.jpg";